'use strict';

exports.__esModule = true;
var _promise = require('babel-runtime/core-js/promise');
var _promise2 = _interopRequireDefault(_promise);
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _stringify = require('babel-runtime/core-js/json/stringify');
var _stringify2 = _interopRequireDefault(_stringify);
var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');
var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
var _checkIsMobile = require('./checkIsMobile');
var _checkIsMobile2 = _interopRequireDefault(_checkIsMobile);
var _timing = require('timing.js');
var _timing2 = _interopRequireDefault(_timing);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SERVER_MONITORING_ERROR = 'Monitoring data should be collected only on client';

/**
 * Takes out required data from window.navigator and window.performance
 * and sends it to /metrics endpoint.
 *
 * Note: works only in browser!
 *
 * @return {Object} - response
 */

exports.default = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
    var _ref2, fetchStart, domInteractive, loadEventEnd, userAgent, response;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (process.env.IS_BROWSER) {
              _context.next = 2;
              break;
            }
            throw new Error(SERVER_MONITORING_ERROR);
          case 2:
            _context.next = 4;
            return getPerformanceTimings();
          case 4:
            _ref2 = _context.sent;
            fetchStart = _ref2.fetchStart;
            domInteractive = _ref2.domInteractive;
            loadEventEnd = _ref2.loadEventEnd;
            userAgent = window.navigator.userAgent.toLowerCase();
            _context.next = 11;
            return fetch('/metrics', {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: (0, _stringify2.default)({
                frontend_dom_interactive_seconds: (domInteractive - fetchStart) / 1000,
                frontend_complete_load_seconds: (loadEventEnd - fetchStart) / 1000,
                frontend_device_type: (0, _checkIsMobile2.default)(userAgent) ? 'mobile' : 'desktop'
              })
            });
          case 11:
            response = _context.sent;
            if (!response.ok) {
              console.error('[MONITORING] ERROR: ', response.statusText); // eslint-disable-line no-console
            }
            return _context.abrupt('return', response);
          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  function collectData() {
    return _ref.apply(this, arguments);
  }
  return collectData;
}();

/**
 * Asynchronously gets the data from the Performance Web API.
 * Uses setTimeout(() => {}, 0) to pause the JavaScript execution to let
 * the rendering threads catch up and calculate reliable value for loadEventEnd.
 *
 * @return {Promise} - data from the Performance Web API
 */

function getPerformanceTimings() {
  return new _promise2.default(function (resolve) {
    setTimeout(function () {
      return resolve(_timing2.default.getTimes());
    }, 0);
  });
}
module.exports = exports['default'];